/**
 * withClasses
 * HOC for wrapping the provided component with ClassesProvider
 */

import React from 'react'
import ClassesProvider from './classes-provider'

export default function withClasses(WrappedComponent) {
  return function ClassesProviderHOC(props) {
    return (
      <ClassesProvider>
        <WrappedComponent {...props} />
      </ClassesProvider>
    )
  }
};
